import React from 'react';
import {
  SectionWrapper,
  GlassContainer,
  AboutSection,
} from './Missions.styles';
import CommitmentCard from '../../components/common/Card/CommitmentCard/CommitmentCard';
import { highlightPhrases } from './highlightPhrases';
import { MissionSection as MissionSectionType } from './missionsData';

interface MissionSectionProps {
  section: MissionSectionType;
}

const MissionSection: React.FC<MissionSectionProps> = ({ section }) => {
  const firstParagraph = section.content[0];
  const remainingParagraphs = section.content.slice(1);

  return (
    <SectionWrapper id={section.id.replace('#', '')}>
      <GlassContainer>
        <AboutSection>
          <div className="image-and-first">
            <img alt={section.label} src={section.imagePath} />
            <CommitmentCard text={highlightPhrases(firstParagraph)} />
          </div>
          <div className="rest-of-paragraphs">
            {remainingParagraphs.map((paragraph, idx) => (
              <CommitmentCard key={idx} text={highlightPhrases(paragraph)} />
            ))}
          </div>
        </AboutSection>
      </GlassContainer>
    </SectionWrapper>
  );
};

export default MissionSection;
